import { commonService } from "../services/common";
import { replaceDomain } from "../help/url";
import { cr } from "fire-wind-water";

class Goto {
  isAsk = false;
  gotoUrls: { a: string; b: boolean; c: string }[] = [];
  isCustomDomain = false;
  whitelist: string[] = [
    "uf.smarket.net.cn",
    "f.smarket.net.cn",
    "file.smarket.net.cn",
    "saas-project.sinobase.cn",
    "activity.sangfor.com.cn",
    "project.sinobase.cn",
  ];
  callback: any = {};

  getDomain(id) {
    const o = { tenantId: id };
    commonService.getDomain(o).subscribe((res) => {
      this.setDomain(res);
    });
  }

  setDomain(res: any) {
    if (parseInt(res.result, 10) === 0) {
      this.isAsk = true;
      this.isCustomDomain = parseInt(res.content.isCustomDomain, 10) === 1;
      this.whitelist.push(res.content.domain);
      this.each();
    }
  }

  each() {
    cr.each(this.gotoUrls, (d) => {
      this.init(d.a, d.b, d.c);
    });
    this.gotoUrls = [];
  }

  isGoto(s: string, b = false) {
    let url: string = s;
    if (this.isCustomDomain) {
      const r = /(\/\/)([^/]+)(\/)?/;
      let am: string | string[] | null = s.match(r);
      am = am ? am[2] : null;
      if (
        am &&
        this.whitelist.indexOf(am) > -1 &&
        this.whitelist.indexOf(am) > -1
      ) {
        if (
          s.indexOf("f.smarket.net.cn/wxoauthb") === -1 &&
          s.indexOf("file.smarket.net.cn/wxoauthb") === -1
        )
          url = replaceDomain(s);
      }
    }
    if (b) {
      return url;
    } else {
      window.location.href = url;
    }
  }

  init(s: string, b: boolean, c?: string) {
    let u = "";
    if (s) {
      if (this.isAsk) {
        u = this.isGoto(s, b);
      } else {
        const m: any = { a: s, b: b, c: s };
        this.gotoUrls.push(m);
      }
      if (c && this.callback[c]) {
        this.callback[c](u);
      }
    }
    return {
      subscribe: (cn: any) => {
        if (this.isAsk) {
          cn(u);
        } else {
          this.callback[s] = cn;
        }
      },
    };
  }
}

export const goto = new Goto();
